export default "<p>sub-menu works!</p>\r\n"